<template>
  <wtFormRight>
    <!-- -TOOLBARS -->
    <template slot="toolbars">
      <Toolbars
        :objProps="objItem"
        :objPropsData="objItemData"
        :urlServices="urlServices"
        :primary_key="primary_key"
        :nameObjData="nameObjData"
        :requiredEndDt="requiredEndDt"
        :noDelete="noDelete"
        :noModify="noModify"
      />
    </template>

    <!-- VIEW TABLE -->
    <template slot="table" v-if="showGrid">
      <SupportTicketHistoricGrid @selectedSupportTicket="objRowSelected = $event" :ticketStatus="ticketStatus"></SupportTicketHistoricGrid>
    </template>

    <!-- VIEW FORM -->
    <template slot="form" v-if="!showGrid" >
      <div class="h-100" @contextmenu.prevent="$refs.menu.open($event, contextMenu)">
        <b-form>
          <div class="row">
            <div class="col-8">
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label for="support_ticket_support_ticket_id">support ticket id</label>
                  <input
                    type="text"
                    class="form-control"
                    id="support_ticket_support_ticket_id"
                    readonly
                    v-model="objItem.support_ticket_id"
                  />
                </div>

                <div class="form-group col-md-3">
                  <label for="support_ticket_init_dt">init dt</label>
                  <input
                    type="date"
                    class="form-control"
                    id="support_ticket_init_dt"
                    readonly
                    v-model.trim="objItemData.init_dt"
                  />
                </div>

                <div class="form-group col-md-3">
                  <label for="support_ticket_end_dt">end dt</label>
                  <input
                    type="date"
                    class="form-control"
                    id="support_ticket_end_dt"
                    readonly
                    v-model.trim="objItemData.end_dt"
                  />
                </div>
              </div>

              <div class="form-row">
                <div class="form-group col-md-9">
                  <label for="support_ticket_description">description</label>
                  <input
                    type="text"
                    class="form-control"
                    id="support_ticket_description"
                    :readonly="noModify"
                    v-model="objItemData.description"
                  />
                </div>
                <div class="form-group col-md-3">
                  <label for="support_ticket_eticket_id">eticket</label>
                  <input
                    type="text"
                    class="form-control"
                    id="support_ticket_eticket_id"
                    readonly
                    v-model="objItem.eticket_id"
                  />
                </div>
              </div>

              <div class="form-row">
                <div class="form-group col-md-12">
                  <label for="support_ticket_detailing">detailing</label>
                  <VueEditor v-model="objItemData.detailing" :disabled="noModify"/> 
                </div>
              </div>
            </div>

            <div class="col-4 ">
              <div class="form-row wt-sub-form wt-doc-layout-container">
                <div class="form-group col-md-12">
                  <label for="support_ticket_ticket_type">ticket types</label>
                  <b-form-select
                    id="support_ticket_ticket_type"
                    class="form-control"
                    :readonly="noModify"
                    :options="ticketTypes"
                    v-model="objItemData.ticket_type"
                  />
                </div>
                
                <div class="form-group col-md-12">
                  <label for="support_ticket_ticket_classification">ticket classification</label>
                  <b-form-select
                    id="support_ticket_ticket_classification"
                    class="form-control"
                    :readonly="noModify"
                    :options="ticketClassification"
                    v-model="objItemData.ticket_classification"
                  />
                </div>

                <div class="form-group col-md-12">
                  <label for="support_ticket_ticket_priority">ticket priority</label>
                  <b-form-select
                    id="support_ticket_ticket_priority"
                    class="form-control"
                    :readonly="noModify"
                    :options="ticketPriority"
                    v-model="objItemData.ticket_priority"
                  />
                </div>
                
                <div class="form-group col-md-12">
                  <label for="support_ticket_ticket_status">ticket status</label>
                  <b-form-select
                    id="support_ticket_ticket_status"
                    class="form-control"
                    disabled
                    :options="ticketStatus"
                    v-model="objItemData.ticket_status"
                  />
                </div>
                
                <div class="form-group col-md-12">
                  <label for="support_ticket_product">product type</label>
                  <b-form-select
                    id="support_ticket_product"
                    class="form-control"
                    :readonly="noModify"
                    :options="productType"
                    v-model="objItemData.product"
                  />
                </div>

                <div class="form-group col-md-12">
                  <label for="support_ticket_product_module">product module</label>
                  <b-form-select
                    id="support_ticket_product_module"
                    class="form-control"
                    :readonly="noModify"
                    :options="productModule"
                    v-model="objItemData.product_module"
                  />
                </div>

                <div class="form-group col-md-12">
                  <label for="support_ticket_product_function">product function</label>
                  <b-form-select
                    id="support_ticket_product_function"
                    class="form-control"
                    :readonly="noModify"
                    :options="productFunction"
                    v-model="objItemData.product_function"
                  />
                </div> 
              </div>
            </div>
          </div>
        </b-form>
        <!-- Context Menu -->
        <ContextMenu ref="menu">
          <template slot-scope="{}">
            <ContextMenuItem v-for="(item, index) in contextMenu.actions" :key="index" @click.native="$refs.menu.executeAction(index)">
              {{ item.action }}
            </ContextMenuItem>
          </template>
        </ContextMenu>   
      </div>
    </template>
  </wtFormRight>
</template>
<script>
/** RECURSOS DO VUE **/
import { baseApiUrl, baseApiPort } from "@/global";
import axios from "axios";
import moment from "moment"


/* COMPONENTS - LAYOUT */
import wtFormRight from "@/components/forms/wtFormRight";
import Toolbars from "@/components/widgets/Toolbars";
import { VueEditor } from "vue2-editor"
import ContextMenu from '@/components/widgets/context-menu/ContextMenu';
import ContextMenuItem from '@/components/widgets/context-menu/ContextMenuItem';

/* COMPONENTS - PAGE */
import SupportTicketHistoricGrid from "./SupportTicketHistoricGrid";

export default {
  name: "SupportTicketHistoric",
  props: {
    ticketTypes: Array,
    ticketClassification: Array,
    ticketPriority: Array,
    ticketStatus: Array,
    productType: Array,
    productModule: Array,
    productFunction: Array,
  },

  /* COMPONENTS IN USE */
  components: { wtFormRight, Toolbars, VueEditor, ContextMenu, ContextMenuItem, SupportTicketHistoricGrid,  },

  /* COMPUTED VARIABLES */
  computed: {
    showGrid() {
      return this.$store.state.layout.showGrid;
    },
    urlServicesStore() {
      return this.$store.state.urlServicesStore;
    },
    objShared() {
      return this.$store.state.objShared;
    },
    objSelected() {
      return this.$store.state.objSelected;
    },
    action() {
      return this.$store.state.action;
    }
  },

  /* VARIABLES */
  data: function() {
    return {
      /* Controls */
      urlServices: "support-ticket-ds/api/internal/support-ticket-historic",
      primary_key: "support_ticket_historic_id",

      /* Objects Page */
      objItem: {},
      objItemData: {},
      objRowSelected: {},
      nameObjData: "support_ticket_historic_data",
      requiredEndDt: false,
      noDelete: true,
      noModify: false,

      /* Context Menu Options */
      contextMenu: {
        row: [],
        actions: []
      },
      contextMenuOptions: [
        { "action":'A', "urlAction": 'support-ticket-ds/api/internal/support-ticket-historic/', "key": "support_ticket_historic_id"},
        { "action":'B', "urlAction": 'support-ticket-ds/api/internal/support-ticket-historic/', "key": "support_ticket_historic_id"},
      ],
    };
  },

  /* METHODS */
  methods: {
    load(objItem) {
      this.$store.commit("setShowLoading", true);
      this.$store.commit("setShowGrid", false);

      const param = {};
      param[`${this.primary_key}`] = objItem[`${this.primary_key}`];
      const url = `${baseApiUrl}:${baseApiPort}/${this.urlServices}/find/`;

      axios.post(url, param).then(res => {
        this.objItem = res.data[0];
        this.objItemData = this.objItem[`${this.nameObjData}`];        
        this.updateActionContextMenu()
        this.noModify = this.objItemData.send_dt !== null
        this.$store.commit("setShowLoading", false);
      });
    },

    updateActionContextMenu() {
      const options = []
      if(this.objItemData.send_dt === null) {
        options.push(this.contextMenuOptions[0])        
      }
      if(this.objItemData.send_dt !== null  && this.objItemData.ticket_status === "AWAITING_SCREENING") {
        options.push(this.contextMenuOptions[1])   
      }
      this.contextMenu.row = this.objItem
      this.contextMenu.actions = options
    }
  },

  /* WATCH */
  watch: {
    objRowSelected() {
      this.load(this.objRowSelected);
      this.$store.commit("setAction", "modify");
    },
    objSelected() {
      if (this.urlServicesStore === this.urlServices) {
        if (Object.entries(this.objSelected).length === 0) {
          this.$emit("supportTicketSelected", null);
        } else {
          this.$emit("supportTicketSelected", this.objSelected.support_ticket_id
          );
        }
      }
    },
    action() {
      if (this.urlServicesStore === this.urlServices) {
        if (this.action === "reset") {
          this.objItem = {};
          this.objItemData = {};
          this.noModify = false;
        }
      }
    },
    objItemData(){
      if (this.urlServicesStore === this.urlServices) {
        if (Object.entries(this.objItemData).length > 0) {
          this.objItemData.ticket_status = 'WAITING_SEND'
          this.objItemData.init_dt = moment().format('YYYY-MM-DD')
        }
      }
    },
  },     
};
</script>